import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

type CheckDisputeResponse = {
  type: 'order' | 'withdrawal';
  order_status: string;
  real_income: number;
};

export const DisputesApi = createApi({
  reducerPath: 'DisputesApi',
  tagTypes: ['Disputes'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (builder) => ({
    postDispute: builder.mutation<any, any>({
      query: (body) => ({
        url: `disputes/`,
        method: 'POST',
        body,
        headers: {},
      }),
    }),
    checkDispute: builder.query<CheckDisputeResponse, any>({
      query: (id) => ({
        url: `disputes/check_order_on_dispute/${id}/`,
        method: 'GET',
        headers: {},
      }),
    }),
    checkMerchantDispute: builder.query<any, any>({
      query: (id) => ({
        url: `disputes/check_order_on_dispute_by_merchant_order_id/${id}/`,
        method: 'GET',
        headers: {},
      }),
    }),
  }),
});

export const { usePostDisputeMutation, useCheckDisputeQuery, useCheckMerchantDisputeQuery } =
  DisputesApi;
